import CustomerUserProvider from './CustomerUserContext';
import CustomerUser from './CustomerUser';

let Index = () => {
    return (
        <CustomerUserProvider>
            <CustomerUser />
        </CustomerUserProvider>
    )
}

export default Index;